import { gql } from '@apollo/client'

export const INVITE_USER = gql`
  mutation InviteUser($inputData: InviteUserInput!) {
    clientInviteUser(inputData: $inputData) {
      id
    }
  }
`
